/**
 * Lightweight device detection helpers.
 */
/**
 * Returns true when the app is running on a mobile device (phone/tablet),
 * based on the browser User-Agent.
 */
export function isMobileDevice() {
    if (typeof navigator === 'undefined')
        return false;
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry/i.test(navigator.userAgent);
}
